import React from "react";
import DeltaChip from "../charts/DeltaChip";
import Sparkline from "../charts/Sparkline";
import LabelWithIcons from "./LabelWithIcons";

// A faixa de numeros principais de um separador (spec do redesign, R4.1; plano dos separadores, E1), num
// painel com divisorias: o valor, a variacao contra o periodo anterior, a mini tendencia dos dois
// periodos e uma linha de contexto. Um numero sem serie diaria nao tem variacao nem tendencia (`change`
// e `spark` a null), e nunca se inventa uma. O que pede atencao tem o numero e o rotulo a ambar e um
// sinal logo a seguir ao rotulo, para a cor nunca ser a unica pista (R1).
// Duas colunas no telemovel e uma linha de `n` a partir do lg. Classes inteiras, para o Tailwind as ver.
const LG_COLUMNS = { 1: "lg:grid-cols-1", 2: "lg:grid-cols-2", 3: "lg:grid-cols-3", 4: "lg:grid-cols-4", 5: "lg:grid-cols-5" };

// As divisorias pelo indice: no telemovel, a esquerda na segunda coluna e por cima a partir da segunda
// linha; no lg, a esquerda em todos menos no primeiro, e nenhuma por cima. Com um numero impar de
// numeros o ultimo ocupa as duas colunas no telemovel, em vez de deixar meia linha vazia: fica so com a
// divisoria de cima, que ja e a dele por estar numa coluna par.
const cellClasses = (index, count) => {
  const left = index % 2 === 1 ? "border-l" : index > 0 ? "lg:border-l" : "";
  const top = index >= 2 ? "border-t lg:border-t-0" : "";
  const span = count % 2 === 1 && index === count - 1 ? "col-span-2 lg:col-span-1" : "";
  return `${left} ${top} ${span}`;
};

const ATTENTION = "var(--color-delta-bad-text)";

// Um numero da faixa, que tambem se usa sozinho (o cartao a ambar dos operadores). Um valor que e texto
// (`textValue`: a sugestao mais usada, a pergunta escrita mais frequente) fica a text-base, parte nos
// espacos e corta a tres linhas com o texto inteiro no `title`; a text-3xl partia "encomenda?" a meio.
// Os numeros ficam a text-3xl.
export const KpiCell = ({ kpi, className = "" }) => {
  const valueColor = kpi.attention ? ATTENTION : "var(--color-text-primary)";
  return (
    <div className={`p-4 space-y-2 min-w-0 ${className}`} style={{ borderColor: "var(--color-border)" }}>
      <p className="text-sm" style={{ color: kpi.attention ? ATTENTION : "var(--color-text-secondary)" }}>
        <LabelWithIcons text={kpi.label} attention={kpi.attention} info={kpi.info} />
      </p>
      {kpi.textValue ? (
        <p className="text-base font-semibold break-words line-clamp-3" title={typeof kpi.value === "string" ? kpi.value : undefined} style={{ color: valueColor }}>
          {kpi.value}
        </p>
      ) : (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-3xl font-semibold tabular-nums break-words min-w-0" style={{ color: valueColor }}>
            {kpi.value}
          </span>
          {kpi.change && <DeltaChip change={kpi.change} />}
        </div>
      )}
      {kpi.spark && <Sparkline current={kpi.spark[0]} previous={kpi.spark[1]} />}
      {kpi.context && (
        <p className="text-xs" style={{ color: "var(--color-text-secondary)" }}>
          {kpi.context}
        </p>
      )}
    </div>
  );
};

const KpiStrip = ({ label, kpis }) => (
  <section
    aria-label={label}
    className={`rounded-xl border grid grid-cols-2 ${LG_COLUMNS[kpis.length]}`}
    style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-surface)" }}
  >
    {kpis.map((kpi, index) => (
      <KpiCell key={kpi.key} kpi={kpi} className={cellClasses(index, kpis.length)} />
    ))}
  </section>
);

export default KpiStrip;
